import { Col, Row } from 'react-bootstrap'

const WhoDoYouTurn = () => (
    <>
    <div className="section-who-do-you-turn">
        <Row className="clearfix">
            <Col lg={{span:6, offset:6}} md={{span:7, offset:5}} className="right-content">
                <h2>Who do you turn to when you want to <em>protect</em> your health?</h2>
                <p>If drugs were the answer, why is our population experiencing such an epidemic of chronic degenerative diseases?</p>
                <p>The problem lies in the fact that the current philosophy  in medicine is to Attack Disease.</p>
                <p>Yet it makes common sense to simply prevent disease and maintain our health rather than to try to regain it after it has been lost.  </p>
                <p><strong>Prevention of disease should be the first order of business for any physician. </strong>But it's not.</p>
                <p>And this leaves you in a situation where you need to become educated how to build health and AVOID disease.</p>
                <p>Because Doctor's weren't taught how to build health using natural nutrition, so it means you have to learn it yourself.</p>
                <p>But where do you go when you want to learn about  the best way to prevent disease and protect your health?</p>
                <p>Is your doctor providing you with this information?</p>
                <div className="testimonial">
                    <p>"Thanks for sharing this report!<br/>
                        So helpful, I had no idea about natural nutrition until I read this."<br/>
                    - Jacob L.</p>
                </div>
            </Col>
        </Row>
    </div>
    <style jsx global>{`

            .section-who-do-you-turn {
                background: url(../images/wyd/bg-girls-jogging01.jpg) no-repeat center left;
                font-size: 18px;
            }

            .section-who-do-you-turn .right-content {
                background: #fbf9fc;
                padding: 65px 15px 60px 15px; 
            }

            .section-who-do-you-turn h2 {
                color: #00aec7;
                font-size: 42px;
                margin-bottom: 35px;
                letter-spacing: 1px;
            }

            .section-who-do-you-turn p {
                margin-bottom: 40px;
                line-height: 30px;
            }

            .section-who-do-you-turn .testimonial {
                max-width: 580px;
                background: #f3f3f3 url(../images/wyd/bg-quote01.png) no-repeat top right;
                padding: 20px 15px 1px;
            }

            @media (min-width: 1590px) {

                .section-who-do-you-turn .right-content {
                    padding: 65px 140px 60px 60px; 
                }

            }

            @media (max-width: 767.98px) {	

                .section-who-do-you-turn {
                    background-size: cover;
                }

                .section-who-do-you-turn h2 {
                    font-size: 32px;
                    margin-bottom: 25px;
                }

                .section-who-do-you-turn .right-content {
                    background: rgba(251,249,252,.9);
                    padding: 30px 15px 30px 15px; 
                }

            }

        `}</style>
    </>
);

export default WhoDoYouTurn;